<section class="home-page">
    <h1>Documentation</h1>
    <ul>
        <li><a [routerLink]="'/privacy-policy'">Politique de confidentialité</a></li>
        <li><a [routerLink]="'/terms-of-service'">Conditions générales d'utilisation</a></li>
    </ul>
</section>